module.exports = __webpack_public_path__ + "img/icon_programming.0ffd050.svg";